import Sha1 from './sha1';
import Md5 from './md5';

// 生成随机码

let radomCode = function(l, str) {
  let asc = parseInt(Math.random() * 125);
  let isConnect = (asc >= 48 && asc < 57) || (asc >= 65 && asc <= 90) || (asc >= 97 && asc <= 122)
  if (isConnect) {
    if (str) {
      if ((str.length + 1) < l) {
        let newStr = str + '' + String.fromCharCode(asc);
        return radomCode(l, newStr);
      } else {
        let newStr = str + '' + String.fromCharCode(asc);
        return newStr;
      }
    } else {
      let newStr = String.fromCharCode(asc);
      if (newStr == 'X') {
        return radomCode(l, str);
      } else {
        return radomCode(l, newStr);
      }

    }
  } else {
    return radomCode(l, str);
  }
};

let paramsCreate = function(){
    let postKey = [];
    let t = (new Date()).valueOf() + '';
    let r = radomCode(3);
    postKey[0] = 'commassistXQBYdcHKSO+RS16jQhf+cRYJqaerqCole';
    postKey[1] = t;
    postKey[2] = r;

    for (let i = 0; i < postKey.length; i++) {
      for (let j = i + 1; j < postKey.length; j++) {
        let comKey1 = postKey[i][0].charCodeAt();
        let comKey2 = postKey[j][0].charCodeAt();
        if (comKey2 < comKey1) {
          let temp = postKey[i];
          postKey[i] = postKey[j];
          postKey[j] = temp;
        }
      }
    }

    let postStr = Md5(Sha1(postKey.join(''))).toUpperCase();

    return {
        t,
        r,
        s:postStr
    }
}

//  验证码请求

let phoneCodeAsk = function({
  type,
  uPhone,
  success
}) {

  let postKey = [];
  let t = (new Date()).valueOf() + '';
  let r = radomCode(3);
  postKey[0] = 'XQBYdcHKSO+RS16jQhf+cRYJqaerqCole';
  postKey[1] = t;
  postKey[2] = r;

  for (let i = 0; i < postKey.length; i++) {
    for (let j = i + 1; j < postKey.length; j++) {
      let comKey1 = postKey[i][0].charCodeAt();
      let comKey2 = postKey[j][0].charCodeAt();
      if (comKey2 < comKey1) {
        let temp = postKey[i];
        postKey[i] = postKey[j];
        postKey[j] = temp;
      }
    }
  }

  let postStr = Md5(Sha1(postKey.join(''))).toUpperCase();

  ajaxFunc({
    url: '/User/User/requestSmsCodeByApp',
    data: {
      type: type,
      cellphone: uPhone,
      s: postStr,
      t: t,
      r: r
    },
    success: function(res) {
      success(res);
    }
  })

}


module.exports = {
  paramsCreate
}



// WEBPACK FOOTER //
// ./src/utils/iparams.js